import { useTranslation } from "react-i18next";
import {
  getBloomsTaxonomyActivities,
  useCreateBloomsTaxonomyActivities,
  useGetBloomsTaxonomyActivities,
} from "@packages/api/madlenAPI";
import {
  BloomsTaxonomyActivitiesCreateRequestDto,
  BloomsTaxonomyActivitiesResponseDto,
} from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import { BloomTaxonomyCard } from "../../../components/blooms-taxonomy-activity/BloomTaxonomyCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateBloomsTaxonomyActivityView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("bloomsTaxonomyActivity.createButton")}
      backPath="/content/blooms-taxonomy-activities"
      themeColor="bloom"
      loadingTitle={t("bloomsTaxonomyActivity.loading_description")}
      errorTitle={t("bloomsTaxonomyActivity.error.title")}
      errorDescription={t("bloomsTaxonomyActivity.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    onCreateAgain,
  }: {
    toolData: BloomsTaxonomyActivitiesResponseDto;
    onCreateAgain: () => void;
  }) => (
    <BloomTaxonomyCard
      bloomsTaxonomyActivity={toolData}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="blooms-taxonomy-activity"
      useCreateTool={useCreateBloomsTaxonomyActivities}
      useGetTool={useGetBloomsTaxonomyActivities}
      getTool={getBloomsTaxonomyActivities}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: BloomsTaxonomyActivitiesResponseDto) =>
        data?.activities && data?.activities.length > 0
      }
    />
  );
};

export default CreateBloomsTaxonomyActivityView;
